import $ from '../../vendor/CustomJquery';
import '../../vendor/choices';

export default class UniversalSelect {

  _config = {};

  _element = null;

  _input = null;

  /**
   *
   * @type {Choices}
   * @private
   */
  _instance = null;

  _events = null;

  _manager = null;

  constructor(element, config, services) {

    this.config = config;
    this.element = element;
    this.input = this._config.input;

    this.injectServices(services);
    this.injectPlaceholder();
    return this.start();

  }

  get config() {
    return this._config;
  }

  set config(value) {
    this._config = value;
  }

  get element() {
    return this._element;
  }

  set element(value) {
    this._element = value;
  }

  get input() {
    return this._input;
  }

  set input(value) {
    this._input = value;
  }

  get instance() {
    return this._instance;
  }

  set instance(value) {
    this._instance = value;
  }

  get events() {
    return this._events;
  }

  set events(value) {
    this._events = value;
  }

  get manager() {
    return this._manager;
  }

  set manager(value) {
    this._manager = value;
  }

  injectServices(services) {
    for (let name in services) {
      this[name] = services[name];
    }
  }

  injectPlaceholder() {

    if (this.config.isMultiple === false && typeof this.config.placeholder == 'string') {
      this.input.prepend('<option value="" placeholder="placeholder" '+ (this.input.find('option[selected]').length === 0 ? 'selected' : '') +'>' + this.config.placeholder + '</option>');
    }

  }

  start() {
    this.instance = new Choices(
      this.input[0],
      this.populateOptions()
    );
    this.bindHandlers();
    return this.instance;
  }

  populateOptions() {

    let options = {
      callbackOnInit: () => {
        this.element.removeClass('is-invisible');
        if (this.config.isWithError) {
          this.element.find('.choices__inner').addClass('is-danger');
        }
      },
      itemComparer: (choice, item) => {
        return choice === item;
        // return choice.toLowerCase() === item.toLowerCase();
        /*
        console.log('itemComparer', choice, item);
        return choice === item;
        */
      },
      placeholderValue: this.config.placeholder,

      silent: false, // TODO: @dev

      delimiter: ',',

      editItems: false,
      removeItems: true,
      removeItemButton: true,

      duplicateItemsAllowed: false,

      searchEnabled: this.config.isWithSearch,
      searchResultLimit: 15,
      searchPlaceholderValue: 'Искать…',

      itemSelectText:      '',
      noResultsText:       'Нет совпадений',
      noChoicesText:       'Нет вариантов',
      emptyInputValueText: 'Введите новый вариант',
      addItemText: (value) => {
        if (this.config.allowCustomItems === true) {
          return 'Добавить <b>' + value + '</b>';
        } else {
          return '';
        }
      },
      classNames: this.classes
    };

    // Set template render
    if (typeof this[`${this.config.template}Template`] === 'function') {
      options.callbackOnCreateTemplates = this[`${this.config.template}Template`];
    }

    if (this.config.allowCustomItems === true) {
      options.addChoices = true;
      options.addItems = true;
      options.editItems = true;
      options.removeItems = true;
      /*
      options.addItemFilterFn = function addItemFilterFn(value){
        // console.log('addItemFilterFn', value);
        if (value === '') return false;
        return true;
      }; */
    } else {
      options.shouldSort = false;
      options.shouldSortItems = false;
      options.searchChoices = true;
    }

    if (typeof this.config.searchAjaxFn === 'function') {
      options.searchAjaxFn = this.config.searchAjaxFn;
    }

    // console.log(this.config.name, options);

    return options;

  }

  get classes() {
    return {
      containerOuter: 'choices',
      containerInner: 'choices__inner',
      input: 'choices__input',
      inputCloned: 'choices__input--cloned',
      list: 'choices__list',
      listItems: 'choices__list--multiple',
      listSingle: 'choices__list--single',
      listDropdown: 'choices__list--dropdown',
      item: 'choices__item',
      itemSelectable: 'choices__item--selectable',
      itemDisabled: 'choices__item--disabled',
      itemOption: 'choices__item--option',
      group: 'choices__group',
      groupHeading : 'choices__heading',
      button: 'choices__button',
      activeState: 'is-active',
      focusState: 'is-focused',
      openState: 'is-open',
      disabledState: 'is-disabled',
      highlightedState: 'is-highlighted',
      hiddenState: 'is-hidden',
      flippedState: 'is-flipped',
      selectedState: 'is-selected'
    };
  }

  bindHandlers() {

    // Force 'change' event
    this.forceChangeEvent();

    // Fix position on opened dropdown
    this.onOpenedDropdown();

    // Place placeholder after removing all items
    this.onItemsRemoving();

    // Track value changes
    this.trackValueChange();

    // Search
    this.onSearch();

  }

  /**
   * Forces change event
   */
  forceChangeEvent() {

    if (this.input.val() !== '' && this.input.val() !== 0) {
      this.input[0].dispatchEvent(new Event('change'));
    }

  }

  /**
   * Fixes position on opened dropdown
   */
  onOpenedDropdown() {

    this.input[0].addEventListener('showDropdown', (event) => {
      let $select = event.currentTarget,
          id = $select.value;

      let $option = $select.parentElement.parentElement.querySelector('.choices__list--dropdown [data-value="' + id + '"]');

      if ($option) {
        $option.classList.add('is-active');
        $option.parentElement.scrollTop = $option.offsetTop; // - $option.parentElement.offsetTop;
        this.instance._highlightChoice($option);
      }
    }, false);

  }

  /**
   * Place placeholder after removing all items
   */
  onItemsRemoving() {
    this.input[0].addEventListener('removeItem', () => {
      let items = this.instance._store.activeItems;

      if (!items.length && typeof this.config.placeholder == 'string') {
        this.instance._addItem({
          value: '',
          label: this.config.placeholder,
          choiceId: '',
          groupId: '',
          placeholder: this.config.placeholder
        });

        this.instance._triggerChange('');
        //this.instance._addItem(placeholder, placeholder, 0, -1, null, true, null);
      }

    });
  }

  /**
   *
   */
  trackValueChange() {
    this.input[0].addEventListener('change', (event) => {
      return this.onValueChanged(event.detail.value);
    }, false);

    setTimeout(() => {
      return this.onValueChanged(this.instance.getValue().value);
    }, 10);
  }

  onValueChanged(value) {
    this.events.publish(this.config.name +'.change', value);
    this.processTargetByValue(value);
  }

  processTargetByValue(value) {

    if (value === '') value = 'blank';

    this.config.target.forEach((targetName) => {

      let instance = this.manager.getInstance(targetName);
      let element = null;

      // Target: block element
      if (this.config.targetType === 'block') {
        element = $('[data-type="' + targetName + '"]');
      } else {

        // Target: dropdown element
        if (typeof instance == 'object') {
          element = $('select[data-type="' + targetName + '"]').closest('.is-uni-select');
        }

      }

      if (element != null) {

        if (value == targetName) {
          element.removeClass('is-hidden');
          if (instance != null) instance.enable();
        } else {
          element.addClass('is-hidden');
          if (instance != null) instance.disable();
        }

      }

    });

  };

  onSearch() {

    this.input.bind('search', (event) => {
      // if a value is present
      if (
        event.detail.value
        && !this.config.allowCustomItems
        && typeof this.config.remoteUrl === 'string'
        && this.config.remoteUrl.length > 0
      ) {

        let remoteParam = (typeof this.config.remoteParam === 'string' ? this.config.remoteParam : 'query');

        fetch(this.config.remoteUrl + '?'+ remoteParam +'=' + event.detail.value, {
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          }
        }).then((response) => {

          response.json().then((data) => {
            this.instance.setChoices(data.data, 'id', 'label', true);
          });

        }).catch((error) => {
          console.error(error);
        });

      }
    });

  }

  /**
   * Country template
   *
   */
  countryTemplate(strToEl) {

    let classNames = this.config.classNames;
    let itemSelectText = this.config.itemSelectText;

    return {
      item: function (classNames, data) {
        return strToEl('\
              <div\
                class="' + String(classNames.item) + ' ' + String(data.highlighted ? classNames.highlightedState : classNames.itemSelectable) + '"\
                data-item\
                data-id="' + String(data.id) + '"\
                data-value="' + String(data.value) + '"\
                ' + String(data.active ? 'aria-selected="true"' : '') + '\
                ' + String(data.disabled ? 'aria-disabled="true"' : '') + '\
                >\
                <span class="geo-label"><span class="flag"><span class="flag-icon flag-icon-' + String(data.value) + '"></span></span> <span>' + String(data.label) + '</span>\
                <button type="button" class="choices__button" data-button="" aria-label="Remove">Remove item</button>\
              </div>\
            ');
      },
      choice: function (classNames, data) {
        return strToEl('\
              <div\
                class="' + String(classNames.item) + ' ' + String(classNames.itemChoice) + ' ' + String(data.disabled ? classNames.itemDisabled : classNames.itemSelectable) + '"\
                data-select-text="' + String(itemSelectText) + '"\
                data-choice \
                ' + String(data.disabled ? 'data-choice-disabled aria-disabled="true"' : 'data-choice-selectable') + '\
                data-id="' + String(data.id) + '"\
                data-value="' + String(data.value) + '"\
                ' + String(data.groupId > 0 ? 'role="treeitem"' : 'role="option"') + '\
                >\
                <span class="geo-label"><span class="flag"><span class="flag-icon flag-icon-' + String(data.value) + '"></span></span> <span>' + String(data.label) + '</span>\
              </div>\
            ');
      }

    }

  }


  deviceTypeTemplate(strToEl) {

    let classNames = this.config.classNames;
    let itemSelectText = this.config.itemSelectText;
    let iconsMapping = {
      phone:  'mobile',
      tablet: 'tablet',
      watch:  'watch'
    };

    return {
      item: function (classNames, data) {
        return strToEl('\
                <div\
                  class="' + String(classNames.item) + ' ' + String(data.highlighted ? classNames.highlightedState : classNames.itemSelectable) + '"\
                  data-item\
                  data-id="' + String(data.id) + '"\
                  data-value="' + String(data.value) + '"\
                  ' + String(data.active ? 'aria-selected="true"' : '') + '\
                  ' + String(data.disabled ? 'aria-disabled="true"' : '') + '\
                  >\
                  <span class="icon"><i class="fal fa-'+ iconsMapping[data.value] +'"></i></span> <span>' + String(data.label) + '</span>\
                </div>\
              ');
      },
      choice: function (classNames, data) {
        return strToEl('\
                <div\
                  class="' + String(classNames.item) + ' ' + String(classNames.itemChoice) + ' ' + String(data.disabled ? classNames.itemDisabled : classNames.itemSelectable) + '"\
                  data-select-text="' + String(itemSelectText) + '"\
                  data-choice \
                  ' + String(data.disabled ? 'data-choice-disabled aria-disabled="true"' : 'data-choice-selectable') + '\
                  data-id="' + String(data.id) + '"\
                  data-value="' + String(data.value) + '"\
                  ' + String(data.groupId > 0 ? 'role="treeitem"' : 'role="option"') + '\
                  >\
                  <span class="icon"><i class="fal fa-'+ iconsMapping[data.value] +'"></i></span> <span>' + String(data.label) + '</span>\
                </div>\
              ');
      }

    }

  }

}